export enum OriginatorOnboardingType {
  EXISTING_ORIGINATOR = 'EXISTING_ORIGINATOR',
  FIRST_ORDER = 'FIRST_ORDER',
  NEW_ORIGINATOR = 'NEW_ORIGINATOR',
  NEW_QUOTE_ORIGINATOR = 'NEW_QUOTE_ORIGINATOR',
}
